import React, { useState, useCallback } from 'react'
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import CheckBox from '@inovua/reactdatagrid-community/packages/CheckBox'

import BoolEditor from '@inovua/reactdatagrid-community/BoolEditor'
// import SelectEditor from '@inovua/reactdatagrid-community/SelectEditor'

import moment from 'moment'
window.moment = moment;

const gridStyle = { minHeight: 550 }

const defaultSortInfo = {name: 'name', dir: '1', type: 'string'}
const songDefaultSortInfo = {name: 'title', dir: '1', type: 'string'}
const filterValue = [
    { name: 'name', operator: 'contains', type: 'string', value: '' },
    { name: 'userName', operator: 'contains', type: 'string', value: '' },
    { name: 'genre', operator: 'contains', type: 'string', value: ''  },
    { name: 'status', operator: 'eq', type: 'select', value: 'PENDING'  },
    { name: 'joinDate', operator: 'after', type: 'date', value: '' },
    { name: 'catalogSize', operator: 'gte', type: 'number', value: '' }
  ]

const columns = [
  { name: 'id', header: 'Id', defaultVisible: false, type: 'string', defaultWidth: 80 },
  { name: 'name', defaultFlex: 1, header: 'Artist Name' },
  { name: 'userName', defaultFlex: 1, header: 'Email Address' },
  { name: 'genre', defaultFlex: 1, header: 'Genre' },
  { 
    name: 'status',
    defaultFlex: 1,
    minWidth: 300,
    header: 'Status',
    filterEditor: SelectFilter,
    filterEditorProps: {
        multiple: false,
        wrapMultiple: false,
        dataSource: ['ACTIVE', 'INACTIVE', 'PENDING', 'CANCELLED'].map(c => {
            return { id: c, label: c}
            }),
    }},
    { name: 'joinDate', 
        defaultFlex: 1,
        header: "Join Date",
        // need to specify dateFormat
        dateFormat: 'MM-DD-YYYY',
        filterEditor: DateFilter,
        filterEditorProps: (props, { index }) => {
        // for range and notinrange operators, the index is 1 for the after field
        return {
            header: "Join Date",
            dateFormat: 'MM-DD-YYYY',
            placeholder: index == 1 ? 'Created date is before...': 'Created date is after...'
        }
        },
        render: ({ value, cellProps: { dateFormat } }) =>
        moment(value).format(dateFormat),
    },
    { name: 'catalogSize', defaultFlex: 1, type: 'number', header: '# Submissions' },
    { name: 'subscriptions', defaultFlex: 1, header: 'Lifetime Subscriptions' },
];

const songColumns = [
  { name: '_id', header: 'Id', defaultVisible: false, type: 'string', defaultWidth: 80 },
  { name: 'title', defaultFlex: 1, header: 'Song Title' },
  { name: 'artist', defaultFlex: 1, header: 'Artist' },
  { name: 'additionalArtists', defaultFlex: 1, header: 'Additional Artists' },
  { name: 'duration', defaultFlex: 1, header: 'Duration', editable: false },
  { name: 'explicit', defaultFlex: 1, header: 'Explicit', type: 'boolean', cellClass: 'align-center', render: ({value}) => <CheckBox checked={value}/>, editor: BoolEditor},
  // { name: 'releaseDate', 
  //       defaultFlex: 1,
  //       header: "Release Date",
  //       // need to specify dateFormat
  //       dateFormat: 'MM-DD-YYYY',
  //       filterEditor: DateFilter,
  //       filterEditorProps: (props, { index }) => {
  //         // for range and notinrange operators, the index is 1 for the after field
  //         return {
  //             header: "Release Date",
  //             dateFormat: 'MM-DD-YYYY',
  //             placeholder: index == 1 ? 'Created date is before...': 'Created date is after...'
  //         }
  //       },
  //       render: ({ value, cellProps: { dateFormat } }) =>
  //       moment(value).format(dateFormat),
  //   },
  // { name: 'ISRC', defaultFlex: 1, header: 'ISRC' },

  // { name: 'active', defaultFlex: 1, header: 'Active', type: 'boolean', cellClass: 'align-center', render: ({value}) => <CheckBox checked={value}/>, editor: BoolEditor},
]

export {gridStyle, filterValue, columns, songColumns, defaultSortInfo, songDefaultSortInfo}